var _rect, _path, _path2, _path3, _path4, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgApptConfirmed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#9EC6C3",
    fillOpacity: 0.21
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3421_4734",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 7,
    width: 18,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4998 14.1252C17.0301 14.1252 18.2707 12.8846 18.2707 11.3543C18.2707 9.82404 17.0301 8.5835 15.4998 8.5835C13.9695 8.5835 12.729 9.82404 12.729 11.3543C12.729 12.8846 13.9695 14.1252 15.4998 14.1252Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.58333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5835 23.2293C7.5835 19.7314 10.7735 16.896 14.7085 16.896",
    stroke: "white",
    strokeWidth: 1.58333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4585 24.021C21.426 24.021 23.021 22.426 23.021 20.4585C23.021 18.491 21.426 16.896 19.4585 16.896C17.491 16.896 15.896 18.491 15.896 20.4585C15.896 22.426 17.491 24.021 19.4585 24.021Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.58333
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0625 19.271V20.8543H20.6458",
    stroke: "black",
    strokeWidth: 1.58333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3421_4734)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 7H25V26H6V7Z",
    fill: "#263077"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApptConfirmed);
export default __webpack_public_path__ + "static/media/appt_confirmed.b0adf898164ad1004d06fc17763ae44c.svg";
export { ForwardRef as ReactComponent };